import { FiArrowRight } from 'react-icons/fi';
import { createIconComponent } from '../createIconComponent';

export const ArrowRight = createIconComponent(FiArrowRight);
